import { BUTTON_VARIANTS } from "../../../../../components/inputs/button-variants";
import { ConfirmModal } from "../../../../../components/modal/components/confirm-modal/confirm-modal";
import { IIntegrationStore } from "../../stores/integration-store";

interface IProps {
    integration: IIntegrationStore;
    onOkClick: () => void;
    onCancelClick: () => void;
    title: string;
}

const ActionConfirmModal: React.FC<IProps> = ({ integration, onOkClick, onCancelClick, title }) => {
    return <ConfirmModal
        title='Integrations - Apps & Services'
        text={<>
            {integration.deleteInfo.message && <div
                dangerouslySetInnerHTML={{ __html: integration.deleteInfo.message }}
            />}
            <p>
                Are you sure you would like to {title} this integration?
            </p>
        </>}
        cancelButton={{
            title: 'Cancel',
            onClick: onCancelClick
        }}
        okButton={{
            title: title,
            onClick: onOkClick,
            variant: BUTTON_VARIANTS.Dismiss
        }}
    />
};

export default ActionConfirmModal;
